import React from 'react';
import styles from './CustomSettingsTableItem.module.scss';
import Text from '../../../../Components/Base/Text/Text';
import { joinClasses } from '../../../../Utils/className.util';

interface Props {
	label: string;
	children: React.ReactNode;
	className?: string;
	allow?: boolean;
}

const CustomSettingsTableItem: React.FC<Props> = ({
	label,
	children,
	className,
	allow = true,
}) => {
	if (!allow) {
		return <></>;
	}

	return (
		<tr className={joinClasses([styles.wrapper, className])}>
			<td>
				<Text tx={label} className={styles.title} />
			</td>
			<td>{children}</td>
		</tr>
	);
};

export default CustomSettingsTableItem;
